import { useState } from 'react';
import { Building2 } from 'lucide-react';
import apiService from '../../services/api';
import AuthLayout from './AuthLayout';

/**
 * Shown after a brand-new user signs in with Google: collect the company / shop
 * name (which becomes their staff-portal identifier), then finish creating the
 * account. Rendered in the same two-panel auth layout — not a popup.
 */
const GoogleCompanyStep = ({ pending, onLogin, onCancel }) => {
  const [companyName, setCompanyName] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const name = companyName.trim();
    if (!name) return;

    setSubmitting(true);
    setError('');
    try {
      const { data } = await apiService.googleAuth(pending.credential, name);
      if (data?.success && data.token) {
        if (data.user) localStorage.setItem('user', JSON.stringify(data.user));
        onLogin(data.token, {
          planId: data.user?.planId,
          isFreemium: data.user?.isFreemium,
        });
      } else {
        setError(data?.message || 'Could not create your account. Please try again.');
        setSubmitting(false);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Could not create your account. Please try again.');
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout
      title="One last step"
      subtitle={
        pending?.email
          ? `Set up your workspace for ${pending.email}`
          : 'Set up your workspace'
      }
      footer={
        <p className="auth-switch">
          <button type="button" onClick={onCancel} className="auth-link">
            ← Back to sign in
          </button>
        </p>
      }
    >
      <form onSubmit={handleSubmit} className="auth-form">
        {error && (
          <div className="auth-error" role="alert">
            {error}
          </div>
        )}

        <div className="auth-field">
          <label htmlFor="googleCompany" className="auth-label">
            Company / shop name
          </label>
          <div className="auth-input-wrap">
            <Building2 size={18} className="auth-input-icon" />
            <input
              id="googleCompany"
              name="googleCompany"
              type="text"
              className="auth-input"
              placeholder="e.g. Mall of Sargodha"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              autoFocus
              required
            />
          </div>
          <p className="auth-hint">This becomes your staff-portal link — you can’t change it later.</p>
        </div>

        <button type="submit" className="auth-submit" disabled={submitting || !companyName.trim()}>
          {submitting ? 'Creating your account…' : 'Continue'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default GoogleCompanyStep;
